module.exports = __webpack_public_path__ + "img/ep8-1b.ffabef76.png";